<template>
    <div>
        <div class="upload-image-container" :style="containerStyle">
            <el-upload
                class="upload-image"
                action="#"
                accept=".jpg,.png"
                :auto-upload="false"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                :show-file-list="showFileList"
            >
                <template v-if="imageUrl">
                    <div class="image-wrapper" :style="imageStyle">
                        <el-image
                            :src="imageUrl"
                            class="preview-image"
                            v-loading="loading"
                            element-loading-text="上传中..."
                        />
                        <div class="image-actions">
                            <el-button
                                type="danger"
                                size="small"
                                circle
                                class="delete-btn"
                                @click.stop="handleRemove"
                            >
                                <i class="el-icon-delete"></i>
                            </el-button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="upload-placeholder" :style="imageStyle">
                        <i class="el-icon-plus"></i>
                        <div class="upload-text">点击上传图片</div>
                    </div>
                </template>
                <!-- <template #tip> </template> -->
            </el-upload>
        </div>
        <div class="el-upload__tip tip-ui" v-if="showTip">
            {{ tip }} {{ `，且不超过${maxSize}MB` }}
        </div>
    </div>
</template>

<script>
import { uploadFile } from "@/api/admin.js";
export default {
    name: "UploadImage",
    props: {
        width: {
            type: [String, Number],
            default: "100px",
        },
        height: {
            type: [String, Number],
            default: "100px",
        },
        showFileList: {
            type: Boolean,
            default: false,
        },
        showTip: {
            type: Boolean,
            default: true,
        },
        tip: {
            type: String,
            default: `只能上传jpg/png文件`,
        },
        maxSize: {
            type: Number,
            default: 2, // MB
        },
        value: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            imageUrl: this.value,
            loading: false,
        };
    },
    watch: {
        value: {
            handler(newVal) {
                this.imageUrl = newVal;
            },
            immediate: true
        }
    },
    computed: {
        containerStyle() {
            return {
                width:
                    typeof this.width === "number"
                        ? `${this.width}px`
                        : this.width,
            };
        },
        imageStyle() {
            return {
                width:
                    typeof this.width === "number"
                        ? `${this.width}px`
                        : this.width,
                height:
                    typeof this.height === "number"
                        ? `${this.height}px`
                        : this.height,
                objectFit: "cover",
            };
        },
    },
    methods: {
        setFiles(file) {
            this.imageUrl = file;
        },
        async handleChange(file) {
            const isImage = file.raw.type.startsWith("image/");
            const isLt2M = file.size / 1024 / 1024 < this.maxSize;

            if (!isImage) {
                this.$message.error("上传文件只能是图片格式!");
                return false;
            }
            if (!isLt2M) {
                this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
                return false;
            }

            this.loading = true;
            // this.imageUrl = URL.createObjectURL(file.raw);

            try {
                const formData = new FormData();
                formData.append("file", file.raw);
                const response = await uploadFile(formData);
                if (response.code === 200) {
                    this.imageUrl = response.data.link;
                    this.$emit("on-change", response.data.link);
                }
            } catch (error) {
                console.error("上传失败:", error);
                this.$message.error("上传失败，请重试");
                this.imageUrl = "";
            } finally {
                this.loading = false;
            }
        },
        handleRemove() {
            this.imageUrl = "";
            this.$emit("on-remove");
        },
        beforeUpload(file) {
            return false; // 阻止自动上传
        },
        clearFiles() {
            this.imageUrl = "";
        },
    },
};
</script>

<style lang="scss" scoped>
.upload-image-container {
    .upload-image {
        :deep(.el-upload) {
            width: 100%;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            transition: all 0.3s;

            &:hover {
                border-color: #409eff;
            }
        }
    }

    .image-wrapper {
        position: relative;
        overflow: hidden;

        .preview-image {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 6px;
            object-fit: cover;
        }

        .image-actions {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s;

            .delete-btn {
                transform: scale(0.8);
                transition: transform 0.3s;
            }
        }

        &:hover {
            .image-actions {
                opacity: 1;

                .delete-btn {
                    transform: scale(1);
                }
            }
        }
    }

    .upload-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #fafafa;

        .el-icon-plus {
            font-size: 28px;
            color: #8c939d;
        }

        .upload-text {
            color: #8c939d;
            font-size: 14px;
            margin-top: 8px;
        }
    }
}
.tip-ui {
    color: #606266;
    margin-top: 0 !important;
}
</style>
